import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import {
    ErrorComponent,
    SideNavBarComponent,
    OutsideLayoutComponent
} from './layouts';

export const AppRoutes: Routes = [
    {
        path: '',
        component: OutsideLayoutComponent,
        loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
    },
    {
        path: 'admin',
        component: SideNavBarComponent,
        //canActivate: [AuthGuard],
        loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule)
    },
    {
        path: 'customer',
        component: SideNavBarComponent,
        //canActivate: [AuthGuard],
        loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule)
    },
    {
        path: '**',
        component: ErrorComponent
    }
];
